import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import styles from 'pages/benefits/member-directory/MemberDirectory.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Benefits/MemberDirectory/components/SectionHeader'));
const SectionHowItWorks = dynamic(() => import('sections/Benefits/MemberDirectory/components/SectionHowItWorks'));
const SectionArticles = dynamic(() => import('sections/Benefits/MemberDirectory/components/SectionArticles'));
const SectionFeatures = dynamic(() => import('sections/Benefits/MemberDirectory/components/SectionFeatures'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionForm = dynamic(() => import('sections/Benefits/MemberDirectory/components/SectionForm'));
const SectionFaq = dynamic(() => import('sections/Benefits/MemberDirectory/components/SectionFaq'));

type MemberDirectoryProps = {
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
};

export default function MemberDirectory({ pageTitle, formUrl, leadSubtype }: MemberDirectoryProps) {
  return (
    <div className={cn('member-directory')}>
      <SectionHeader />
      <SectionHowItWorks />
      <SectionArticles />
      <SectionFeatures />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionForm 
        pageTitle={pageTitle}
        formUrl={formUrl}
        leadSubtype={leadSubtype}
      /> */}
      <SectionFaq />
    </div>
  );
}

export const getStaticProps = async () => {
  // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
  // const FormParameters = {
  //   pageTitle: LeadFormParameters.memberDirectory.pageTitle,
  //   formUrl: LeadFormParameters.memberDirectory.formUrl,
  //   leadSubtype: LeadFormParameters.memberDirectory.leadSubtype,
  // };

  return {
    props: {
      title: 'Freight Forwarders List & Member Directory | DF Alliance',
      description: 'DF Alliance’s Logistics Member Directory features trusted freight forwarders in 150+ countries. Search by region, service, or specialization',
      path: '/benefits/member-directory',
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters,
    },
  };
};

MemberDirectory.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
